import {GAME_UI_PHASES, getGameUiPhase} from './getGameUiPhase';

// Цвета фаз дизайн-системы матча — те же значения, что токены --gui-ph-* в
// src/styles/gameUi/tokens.css (их сверяет тест). В JS они нужны там, где цвет
// ставится инлайном и по нему считается контраст подписи: кнопка хода
export const GAME_UI_PHASE_COLORS = Object.freeze({
  [GAME_UI_PHASES.PREP]: '#6e7379',
  [GAME_UI_PHASES.SUPPLY]: '#d68a5a',
  [GAME_UI_PHASES.CONSTRUCTION]: '#634632',
  [GAME_UI_PHASES.WAR]: '#8f1a28',
  [GAME_UI_PHASES.END]: '#8a6d1f',
  [GAME_UI_PHASES.RUINS_INCOME]: '#7f848c',
});

export const getGameUiPhaseColor = (phase, gameResults) => GAME_UI_PHASE_COLORS[getGameUiPhase(phase, gameResults)];
